import React from 'react';
import { queries } from '../../../graphql/graphql';
import ListContainer from '../../../components/containers/AdminList';

const ListUsers: React.FC = () => {
  return (
    <ListContainer
      prefix="user"
      query={queries.users.USERS}
      inline={true}
      editable={true}
      canCreate={true}
      adminView={true}
    />
  );
};

export default ListUsers;
